import type { IconData } from '@stacksjs/iconify-core'

export const ci1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#00cd00\" d=\"M341.5 0H512v512H341.5z\"/><path fill=\"#ff9a00\" d=\"M0 0h170.3v512H0z\"/><path fill=\"#fff\" d=\"M170.3 0h171.2v512H170.3z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ci1x1
